package fr.frux.shared.data.local

import fr.frux.core.common.logging.Logger
import fr.frux.core.database.FruxDatabase
import fr.frux.shared.dto.SpeciesDto
import kotlinx.serialization.SerializationException
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.json.Json

/**
 * Ligne unique `species_cache` : le referentiel se consomme toujours en liste entiere, le payload
 * est la liste de [SpeciesDto] serialisee. Un payload illisible (schema DTO qui a change depuis
 * l'ecriture) vaut cache absent : on purge et on laisse le reseau reconstruire.
 */
class SqlDelightSpeciesLocalDataSource(
    private val database: FruxDatabase,
    private val now: () -> Long,
) : SpeciesLocalDataSource {
    private val json = Json { ignoreUnknownKeys = true }
    private val serializer = ListSerializer(SpeciesDto.serializer())

    override suspend fun read(): CachedSpecies? {
        val row = database.speciesCacheQueries.select().executeAsOneOrNull() ?: return null
        return try {
            CachedSpecies(etag = row.etag, species = json.decodeFromString(serializer, row.payload))
        } catch (e: SerializationException) {
            Logger.e(TAG, "⚠️ Payload du cache especes illisible, purge", e)
            database.speciesCacheQueries.clear()
            null
        } catch (e: IllegalArgumentException) {
            Logger.e(TAG, "⚠️ Payload du cache especes invalide, purge", e)
            database.speciesCacheQueries.clear()
            null
        }
    }

    override suspend fun write(
        etag: String?,
        species: List<SpeciesDto>,
    ) {
        database.speciesCacheQueries.put(
            etag = etag,
            payload = json.encodeToString(serializer, species),
            cached_at = now(),
        )
    }

    companion object {
        private const val TAG = "SpeciesLocalDataSource"
    }
}
